import * as types from "./types";
import { lensPath, set } from "ramda";

export const bookingSettingsMutations = {
  [types.BookingSettingsData.SET.ALL](state, payload) {
    state.bookingSettingsData = payload;
  },
  [types.UpdateConf](state, payload) {
    const { name, key, value, conf } = payload;
    const newVal = value ? 1 : 0;
    const flagLens = lensPath(["conf", conf, key, name]);
    state.bookingSettingsData = set(
      flagLens,
      newVal,
      state.bookingSettingsData
    );
    // console.log(newVal, state.bookingSettingsData.conf);
  },

  [types.RssList.SET.ALL](state, payload) {
    state.rssList = payload;
  }
};
